var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApkFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1130_18539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1130_18539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 23.75H21.25C21.1667 22.7292 20.8542 21.7917 20.3125 20.9375C19.7708 20.0833 19.0625 19.4062 18.1875 18.9062L19.375 16.7812C19.4167 16.6979 19.4271 16.6042 19.4063 16.5C19.3854 16.3958 19.3229 16.3229 19.2188 16.2813C19.1354 16.2396 19.0469 16.2292 18.9531 16.25C18.8594 16.2708 18.7917 16.3229 18.75 16.4062L17.5313 18.5938C17.1146 18.4271 16.6979 18.2969 16.2813 18.2031C15.8646 18.1094 15.4375 18.0625 15 18.0625C14.5625 18.0625 14.1354 18.1094 13.7188 18.2031C13.3021 18.2969 12.8854 18.4271 12.4688 18.5938L11.25 16.4062C11.2083 16.3021 11.1406 16.25 11.0469 16.25C10.9531 16.25 10.8542 16.2708 10.75 16.3125L10.625 16.7812L11.8125 18.9062C10.9375 19.4062 10.2292 20.0833 9.6875 20.9375C9.14583 21.7917 8.83333 22.7292 8.75 23.75ZM12.1875 21.875C12.0208 21.875 11.875 21.8125 11.75 21.6875C11.625 21.5625 11.5625 21.4167 11.5625 21.25C11.5625 21.0833 11.625 20.9375 11.75 20.8125C11.875 20.6875 12.0208 20.625 12.1875 20.625C12.3542 20.625 12.5 20.6875 12.625 20.8125C12.75 20.9375 12.8125 21.0833 12.8125 21.25C12.8125 21.4167 12.75 21.5625 12.625 21.6875C12.5 21.8125 12.3542 21.875 12.1875 21.875ZM17.8125 21.875C17.6458 21.875 17.5 21.8125 17.375 21.6875C17.25 21.5625 17.1875 21.4167 17.1875 21.25C17.1875 21.0833 17.25 20.9375 17.375 20.8125C17.5 20.6875 17.6458 20.625 17.8125 20.625C17.9792 20.625 18.125 20.6875 18.25 20.8125C18.375 20.9375 18.4375 21.0833 18.4375 21.25C18.4375 21.4167 18.375 21.5625 18.25 21.6875C18.125 21.8125 17.9792 21.875 17.8125 21.875ZM7.5 27.5C6.8125 27.5 6.22396 27.2552 5.73438 26.7656C5.24479 26.276 5 25.6875 5 25V5C5 4.3125 5.24479 3.72396 5.73438 3.23438C6.22396 2.74479 6.8125 2.5 7.5 2.5H17.5L25 10V25C25 25.6875 24.7552 26.276 24.2656 26.7656C23.776 27.2552 23.1875 27.5 22.5 27.5H7.5ZM16.25 11.25V5H7.5V25H22.5V11.25H16.25Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApkFile);
export default __webpack_public_path__ + "static/media/ApkFile.4e871949e8a29d6999be13a49a73d374.svg";
export { ForwardRef as ReactComponent };